<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約施設情報詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>予約施設情報詳細（追加・編集）の説明</span></mat-card-title>
    </mat-card-header>

  <!-- 予約説明 -->
  <mat-card-content>
    <div class="manual-explain-title">
      ▼予約説明ページ
    </div>
    <div class="manual-img">
      <img src="assets/img/manual/reservation-facility-dialog1.png" width="100%">
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/A.png"> 閉じるボタン
    </div>
    <div class="manual-explain">
      クリックすることでダイアログを閉じます。<br>
      編集した内容は保存されません。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/B.png"> 編集ページ切り替え
    </div>
    <div class="manual-explain">
      予約説明／予約入力／予約メール／SPLATSキーの中から選択した編集ページを表示します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/C.png"> ID
    </div>
    <div class="manual-explain">
      IDを設定します。<br>
      <span class="manual-explain-notes">※必須項目</span>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/D.png"> 属性
    </div>
    <div class="manual-explain">
      属性を選択します。<br>
      ※<a [href]="reservationFacilityAttributeDialogLink">予約施設属性画面</a>で登録された情報から選択します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/E.png"> 名称
    </div>
    <div class="manual-explain">
      名称を設定します。<br>
      編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      <span class="manual-explain-notes">※必須項目</span>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/F.png"> 詳細
    </div>
    <div class="manual-explain">
      詳細を設定します。<br>
      編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      <span class="manual-explain-notes">※必須項目</span>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/G.png"> 表示期間（開始日時ー終了日時）
    </div>
    <div class="manual-explain">
      ユーザー画面上に予約ページを表示する期間を指定することができます。<br>
      未指定の場合は常時されます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/H.png"> 予約施設画像ファイル
    </div>
    <div class="manual-explain">
      予約施設のメイン画像を設定します。<br>
      ファイル追加ボタンからファイルを選択します。<br>
      ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
      ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
      メイン画像は複数登録可能です。複数登録した場合、画像はスライド表示されます。<br>
      また、予約施設画像はドラッグ&ドロップで並び替えが可能です。<br>
      ※画像の推奨サイズ（縦横比）は以下になります。<br>
      &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/I.png"> マップ情報
    </div>
    <div class="manual-explain">
      マップ情報を設定します。<br>
      マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/J.png"> MAPページに位置を表示する
    </div>
    <div class="manual-explain">
      チェックを入れることで、MAPページにGoogleMapを表示しピンを立てます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/K.png"> 更新ボタン
    </div>
    <div class="manual-explain">
      クリックすることで編集内容が更新されます。
    </div>

  </mat-card-content>
  <div>
    <br><br>
  </div>

  <!-- 予約入力 -->
  <mat-card-content>
    <div class="manual-explain-title">
      ▼予約入力ページ
    </div>
    <div class="manual-img">
      <img src="assets/img/manual/reservation-facility-dialog2.png" width="100%">
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/A.png"> 予約可能期間（開始日ー終了日）
    </div>
    <div class="manual-explain">
      予約可能期間（開始日ー終了日）を設定します。<br>
      開始日は当日、1日前、2日前… 90日前の中から選択します。<br>
      終了日は1日前、2日前… 90日前の中から選択します。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/B.png"> キャンセル期限
    </div>
    <div class="manual-explain">
      キャンセル期限を設定します。<br>
      当日、1日前、2日前… 90日前の中から選択します。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/C.png"> 抽選日
    </div>
    <div class="manual-explain">
      抽選日を設定します。<br>
      予約方式（赤枠G）で「抽選」の場合のみ設定が可能です。<br>
      抽選日に設定した日付の正午に自動抽選が行われます。最大予約数（赤枠I、赤枠J）までの予約が確定、残りの予約は落選となります。<br>
      当日、1日前、2日前… 90日前の中から選択します。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/D.png"> 予約限定
    </div>
    <div class="manual-explain">
      予約可能期間の中で、予約日を限定したい場合に設定します。<br>
      予約限定（開始＋終了）を指定した場合は、その期間のみ予約が可能となります。<br>
      予約限定を単日とする場合は予約限定（開始）のみ設定します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/E.png"> 定休日
    </div>
    <div class="manual-explain">
      予約施設の定休日を設定します。<br>
      定休日とする曜日にチェックをつけます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/F.png"> 予約条件（予約開始／終了、定休日など）を表示しない
    </div>
    <div class="manual-explain">
      ユーザー画面の日付選択画面に表示する、予約開始／終了、定休日などの表示有無を選択します。<br>
      チェックを入れると非表示になります。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/G.png"> 予約方式
    </div>
    <div class="manual-explain">
      予約方式を選択します。<br>
      「先着順」は先着順に最大予約数まで予約できます。予約すると予約状況は確定となります。<br>
      「抽選」と「保留」は最大予約数に関係なく予約できます。予約すると予約状況は受付中となります。<br>
      状態が受付中の予約は<a [href]="confirmReservationDialogLink">受付中の予約状況の確定・落選ダイアログ</a>で、予約状況を確定か落選に変更できます。<br>
      「抽選」は抽選日（赤枠C）に設定した日付の正午に自動抽選が行われます。最大予約数（赤枠I、赤枠K）分の予約の状況が確定、残りの予約の状況が落選となります。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/H.png"> 予約単位
    </div>
    <div class="manual-explain">
      予約単位を選択します。日付（期間）／時間枠のいずれかを選択します。<br>
      日付（期間）を選択した場合は、日単位での予約を可能とします。最大予約数（赤枠I）と利用日（延泊）を表示しない（赤枠J）が表示されます。<br>
      時間枠を選択した場合は、時間枠単位での予約を可能とします。時間枠（赤枠K）が表示されます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/I.png"> 最大予約数
    </div>
    <div class="manual-explain">
      予約単位（赤枠H）で「日付（期間）」を選択した場合に表示されます。<br>
      1日あたりの最大予約数を入力します。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/J.png"> 利用日（延泊）を表示しない
    </div>
    <div class="manual-explain">
      予約単位（赤枠H）で「日付（期間）」を選択した場合に表示されます。<br>
      ユーザー画面の延泊日の表示有無を選択します。<br>
      チェックを入れると非表示になります。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/K.png"> 時間枠
    </div>
    <div class="manual-explain">
      予約単位（赤枠H）で「時間枠」を選択した場合に表示されます。<br>
      1日の中で予約可能な時間枠（開始時間ー終了時間）を設定します。<br>
      ユーザーが予約時に選択できる時間枠は１日あたり１つまでとなりますが、
      「１日あたりの時間帯の複数選択を可能にする」をチェックすると、複数選択が可能となります。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/L.png"> 予約設問（基本項目：チェックありで表示）
    </div>
    <div class="manual-explain">
      予約時にユーザー画面に表示する基本項目の表示有無を設定します。<br>
      チェックを入れた項目が表示されます。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/M.png"> 予約設問（基本項目：「備考欄」を別名にしたい場合）
    </div>
    <div class="manual-explain">
      ユーザー予約時の「備考欄」入力フォームのタイトルを設定します。<br>
      編集ボタンから<a [href]="userInputTitleDialogLink">編集用ダイアログ</a>を開き設定します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/N.png"> 予約設問（カスタム項目）
    </div>
    <div class="manual-explain">
      予約時にユーザー画面（基本項目の下）に表示するカスタム項目を選択します。<br>
      カスタム項目は、予約設問機能から登録可能です。<br>
    </div>

  </mat-card-content>
  <div>
    <br><br>
  </div>

  <!-- 予約メール -->
  <mat-card-content>
    <div class="manual-explain-title">
      ▼予約メールページ
    </div>
    <div class="manual-img">
      <img src="assets/img/manual/reservation-facility-dialog3.png" width="100%">
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/A.png"> ユーザー予約完了時：メール文面の設定
    </div>
    <div class="manual-explain">
      ▼予約入力ページの予約方式（赤枠G）が「先着順」の場合の予約時、予約方式が「抽選」か「保留」の場合の予約確定時に送信されるメールの文面を設定します。<br>
      <br>
      メールタイトル：<span class="manual-explain-notes">※必須項目</span><br>
      ユーザーに送信する予約完了メールのタイトルを設定します。<br>
      メール本文（文頭）：<span class="manual-explain-notes">※必須項目</span><br>
      ユーザーに送信する予約完了メールの文頭に配置する文章を設定します（下記文面中★の箇所）。<br>
      メール本文（文中）：<br>
      ユーザーに送信する予約完了メールの文中に配置する文章を設定します（下記文面中★★の箇所）。<br>
      メール本文（文末）：<br>
      ユーザーに送信する予約完了メールの文末に配置する文章を設定します（下記文面中★★★の箇所）。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      <br>
      メール本文の構成は下記となります。<br>
      ------------------------------------------------<br>
      <br>
      ★メール本文（文頭）<br>
      <br>
      ▼ご予約内容<br>
      予約番号 : 12345678<br>
      会社名 : 株式会社〇〇<br>
      部署 : 〇〇部<br>
      役職 : 部長<br>
      お名前 : 山田 太郎<br>
      お名前カナ : ヤマダ タロウ<br>
      メールアドレス : xxxxxxxxxxx<br>
      携帯電話番号 : 09011112222<br>
      <br>
      利用日 :<br>
      &nbsp;&nbsp;&nbsp;2024-02-23<br>
      利用時間 :<br>
      &nbsp;&nbsp;&nbsp;11:00 - 14:00<br>
      予約キャンセル期限 :<br>
      &nbsp;&nbsp;&nbsp;利用日当日<br>
      <br>
      ご要望 :<br>
      特になし<br>
      <br>
      予約キャンセルは下記リンク先よりお願いします。<br>
      （※予約番号、メールアドレスが必要となります。キャンセル期限にお気をつけください。）<br>
      &nbsp;&nbsp;&nbsp;https://xxxxxxxxxxx/reservation-cancel/000001<br>
      <br>
      ★★メール本文（文中）<br>
      <br>
      * 本メールは施設のご利用予約により自動送信しております。<br>
      * 本メールは送信専用のため、ご返信いただいてもお答えできません。ご了承ください。<br>
      <br>
      ★★★メール本文（文末）<br>
      ------------------------------------------------<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/B.png"> ユーザー予約完了時：事務局への通知メール文面の設定
    </div>
    <div class="manual-explain">
      メール本文（文頭）：<br>
      事務局へ送信する予約完了メールの文頭に配置する文章を設定します（下記文面中★の箇所）。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      <br>
      メール本文の構成は下記となります。<br>
      ------------------------------------------------<br>
      <br>
      ★メール本文（文頭）<br>
      <br>
      ▼ご予約内容<br>
      予約名 : テニスコート<br>
      予約番号 : 12345678<br>
      メール : xxxxxxxxx&#64;test.com<br>
      利用日 :<br>
      &nbsp;&nbsp;&nbsp;2024-02-23<br>
      利用時間 :<br>
      &nbsp;&nbsp;&nbsp;11:00 - 14:00<br>
      ------------------------------------------------<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/C.png"> ユーザー予約完了メール本文表示制御
    </div>
    <div class="manual-explain">
      予約完了時にユーザーに送信されるメール文面中（ユーザー予約完了時：メール文面の設定のメール本文を参照）で<br>
      表示したくない項目がある場合にチェックします。<br>
      対象項目は、予約キャンセル期限、予約キャンセルリンクとなります。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/D.png"> ユーザー予約キャンセル時：メール文面の設定
    </div>
    <div class="manual-explain">
      メールタイトル：<br>
      ユーザーに送信する予約キャンセルメールのタイトルを設定します。<br>
      メール本文（文頭）：<br>
      ユーザーに送信する予約キャンセルメールの文頭に配置する文章を設定します。<br>
      メール本文（文中）：<br>
      ユーザーに送信する予約キャンセルメールの文中に配置する文章を設定します。<br>
      メール本文（文末）：<br>
      ユーザーに送信する予約キャンセルメールの文末に配置する文章を設定します。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      ※メール本文の構成は、ユーザー予約完了時：メール文面の設定のメール本文を参照<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/E.png"> ユーザー予約キャンセル時：事務局への通知メール文面の設定
    </div>
    <div class="manual-explain">
      メール本文（文頭）：<br>
      事務局へ送信する予約キャンセルメールの文頭に配置する文章を設定します（ユーザー予約完了時：事務局への通知メール文面の設定のメール本文を参照）。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/F.png"> リマインドメール：メール文面の設定
    </div>
    <div class="manual-explain">
      メールタイトル：<br>
      ユーザーに送信するリマインドメールのタイトルを設定します。<br>
      メール本文（文頭）：<br>
      ユーザーに送信するリマインドメールの文頭に配置する文章を設定します。<br>
      メール本文（文中）：<br>
      ユーザーに送信するリマインドメールの文中に配置する文章を設定します。<br>
      メール本文（文末）：<br>
      ユーザーに送信するリマインドメールの文末に配置する文章を設定します。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      ※メール本文の構成は、ユーザー予約完了時：メール文面の設定のメール本文を参照<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/G.png"> リマインドメール設定
    </div>
    <div class="manual-explain">
      予約が完了したユーザーに利用日の1〜7日前にリマインドメールを送信します。<br>
      1〜7日前の中から最大2つ選択が可能です。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/H.png"> 事務局へのメール通知設定
    </div>
    <div class="manual-explain">
      予約完了時／予約キャンセル時に事務局へメール通知したい場合は、メールアドレスを登録します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/I.png"> ユーザー予約保留時：メール文面の設定
    </div>
    <div class="manual-explain">
      ▼予約入力ページの予約方式（赤枠G）が「抽選」か「保留」の場合に表示されます。<br>
      予約した際に送信するメール文面を設定します。<br>
      <br>
      メールタイトル：<br>
      ユーザーに送信する予約保留メールのタイトルを設定します。<br>
      メール本文（文頭）：<br>
      ユーザーに送信する予約保留メールの文頭に配置する文章を設定します。<br>
      メール本文（文中）：<br>
      ユーザーに送信する予約保留メールの文中に配置する文章を設定します。<br>
      メール本文（文末）：<br>
      ユーザーに送信する予約保留メールの文末に配置する文章を設定します。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      ※メール本文の構成は、ユーザー予約完了時：メール文面の設定のメール本文を参照<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/J.png"> ユーザー予約落選時：メール文面の設定
    </div>
    <div class="manual-explain">
      ▼予約入力ページの予約方式（赤枠G）が「抽選」か「保留」の場合に表示されます。<br>
      予約を落選させた際に送信するメール文面を設定します。<br>
      <br>
      メールタイトル：<br>
      ユーザーに送信する予約落選メールのタイトルを設定します。<br>
      メール本文（文頭）：<br>
      ユーザーに送信する予約落選メールの文頭に配置する文章を設定します。<br>
      メール本文（文中）：<br>
      ユーザーに送信する予約落選メールの文中に配置する文章を設定します。<br>
      メール本文（文末）：<br>
      ユーザーに送信する予約落選メールの文末に配置する文章を設定します。<br>
      編集ボタンから<a [href]="sendMailMessageDialogLink">編集用ダイアログ</a>を開き設定します。<br>
      ※メール本文の構成は、ユーザー予約完了時：メール文面の設定のメール本文を参照<br>
    </div>

  </mat-card-content>

  <!-- SPLATSキー -->
  <mat-card-content>
    <div class="manual-explain-title">
      ▼SPLATSキーページ
    </div>
    <div class="manual-img">
      <img src="assets/img/manual/reservation-facility-dialog4.png" width="100%">
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/A.png"> 環境
    </div>
    <div class="manual-explain">
      キーボックスの所属する環境を選択します。<br>
      環境を選択すると、その環境で所有するキーボックスの一覧をキーボックスに表示します。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/B.png"> キーボックス
    </div>
    <div class="manual-explain">
      キーボックスを選択します。<br>
      キーボックスを選択すると、そのキーボックスで所有するキーの一覧をキーに表示します。<br>
      ※キーボックスは、<a [href]="facilityDialogLink">施設情報（追加・編集）画面</a>で事前にキーボックスを登録してある必要があります。<br>
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/C.png"> キー
    </div>
    <div class="manual-explain">
      キーを選択します。<br>
      他の予約施設で使用中のキーの名称は赤字で表示されます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/D.png"> 借受猶予時間
    </div>
    <div class="manual-explain">
      キーの借り受けの猶予時間を選択します。<br>
      例えば予約施設の利用開始時刻が9:00で借受猶予時間を10分に設定した場合は、8:50からキーを借り受けることができます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/E.png"> 返却猶予時間
    </div>
    <div class="manual-explain">
      キーの返却の猶予時間を選択します。<br>
      例えば予約施設の利用終了時刻が12:00で返却猶予時間を10分に設定した場合は、12:10までキーを返却することができます。
    </div>

    <div class="manual-explain-title">
      <img src="assets/img/manual/F.png"> 設問（基本項目：チェックありで出力）
    </div>
    <div class="manual-explain">
      キーボックス開扉時に利用するQRコードと共に出力する基本項目の出力有無を設定します。(最大5つ)<br>
      チェックを入れた項目が出力されます。<br>
    </div>


  </mat-card-content>


  </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reservation Facility Information Details (Add/Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>Explanation of Reservation Facility Information Details (Add/Edit)</span></mat-card-title>
    </mat-card-header>

    <!-- Reservation Description -->
    <mat-card-content>
      <div class="manual-explain-title">
        ▼Reservation Description Page
      </div>
      <div class="manual-img">
        <img src="assets/img/manual/en_reservation-facility-dialog1.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> Close Button
      </div>
      <div class="manual-explain">
        Click to close the dialog.<br>
        Any edited content will not be saved.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> Edit Page Switching
      </div>
      <div class="manual-explain">
        Displays the selected edit page from Reservation Description/Reservation Input/Reservation Email/SPLATS Key.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> ID
      </div>
      <div class="manual-explain">
        Set the ID.<br>
        <span class="manual-explain-notes">*Required field</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> Attribute
      </div>
      <div class="manual-explain">
        Select the attribute.<br>
        *Select from information registered on the <a [href]="reservationFacilityAttributeDialogLink">Reservation Facility Attribute Screen</a>.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> Name
      </div>
      <div class="manual-explain">
        Set the name.<br>
        Open the <a [href]="nameDialogLink">edit dialog</a> from the edit button to configure.<br>
        <span class="manual-explain-notes">*Required field</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> Detail
      </div>
      <div class="manual-explain">
        Set the details.<br>
        Open the <a [href]="descDialogLink">edit dialog</a> from the edit button to configure.<br>
        <span class="manual-explain-notes">*Required field</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> Display Period (Start Date-End Date)
      </div>
      <div class="manual-explain">
        You can specify the period to display the reservation page on the user screen.<br>
        If not specified, it will be displayed at all times.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/H.png"> Reservation Facility Image Files
      </div>
      <div class="manual-explain">
        Set the main image for the reservation facility.<br>
        Select files using the Add File button.<br>
        *Files must be uploaded in advance on the <a [href]="uploaderLink">Upload Files screen</a>.<br>
        *Image settings for each language are possible. If there is no image for the corresponding language, English images will be displayed, and if no English image is registered, Japanese images will be displayed.<br>
        Multiple main images can be registered. When multiple images are registered, they will be displayed as a slideshow.<br>
        Reservation facility images can also be reordered by drag & drop.<br>
        *The recommended image size (aspect ratio) is as follows:<br>
        &nbsp;&nbsp;Main image: 1:1 (Example) Height 1400px, Width 1400px
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> Map Information
      </div>
      <div class="manual-explain">
        Set the map information.<br>
        Can be specified by search keywords within the map or by latitude and longitude.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/J.png"> Show Location on MAP Page
      </div>
      <div class="manual-explain">
        Check to display Google Map with a pin on the MAP page.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/K.png"> Update Button
      </div>
      <div class="manual-explain">
        Click to update the edited content.
      </div>

    </mat-card-content>
    <div>
      <br><br>
    </div>

    <!-- Reservation Input -->
    <mat-card-content>
      <div class="manual-explain-title">
        ▼Reservation Input Page
      </div>
      <div class="manual-img">
        <img src="assets/img/manual/en_reservation-facility-dialog2.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> Reservation Period (Start Date-End Date)
      </div>
      <div class="manual-explain">
        Set the reservation period (start date-end date).<br>
        For the start date, select from today, 1 day ago, 2 days ago... up to 90 days ago.<br>
        For the end date, select from 1 day ago, 2 days ago... up to 90 days ago.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> Cancellation Deadline
      </div>
      <div class="manual-explain">
        Set the cancellation deadline.<br>
        Select from today, 1 day ago, 2 days ago... up to 90 days ago.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Lottery Date
      </div>
      <div class="manual-explain">
        Set the lottery date.<br>
        Settings are only possible when the reservation method (red frame G) is "Lottery".<br>
        Automatic lottery will be held at noon on the date set as the lottery date. Reservations up to the maximum reservation number (red frames I, J) will be confirmed, and remaining reservations will be rejected.<br>
        Select from today, 1 day ago, 2 days ago... up to 90 days ago.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> Reservation Limitation
      </div>
      <div class="manual-explain">
        Set when you want to limit reservation dates within the reservation period.<br>
        If you specify reservation limitation (start + end), reservations will only be possible during that period.<br>
        If you want to set the reservation limitation to a single day, only set the reservation limitation (start).
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> Regular Holidays
      </div>
      <div class="manual-explain">
        Set the regular holidays for the reservation facility.<br>
        Check the days of the week that should be regular holidays.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> Do Not Display Reservation Conditions (Reservation Start/End, Regular Holidays, etc.)
      </div>
      <div class="manual-explain">
        Select whether to display reservation start/end, regular holidays, etc. on the date selection screen of the user interface.<br>
        Checking this will hide the display.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> Reservation Method
      </div>
      <div class="manual-explain">
        Select the reservation method.<br>
        "First-come, first-served" allows reservations up to the maximum number on a first-come, first-served basis. The reservation status becomes confirmed upon reservation.<br>
        "Lottery" and "Hold" allow reservations regardless of the maximum number. The reservation status becomes pending upon reservation.<br>
        Reservations with pending status can be changed to confirmed or rejected using the <a [href]="confirmReservationDialogLink">Pending Reservation Status Confirmation/Rejection Dialog</a>.<br>
        "Lottery" automatically conducts a lottery at noon on the date set as the lottery date (red frame C). The status of reservations up to the maximum number (red frames I, K) becomes confirmed, and the status of remaining reservations becomes rejected.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/H.png"> Reservation Unit
      </div>
      <div class="manual-explain">
        Select the reservation unit. Choose either Date (Period) or Time Slot.<br>
        If Date (Period) is selected, reservations by day are enabled. Maximum reservation number (red frame I) and Do not display usage days (extended stay) (red frame J) are displayed.<br>
        If Time Slot is selected, reservations by time slot are enabled. Time slots (red frame K) are displayed.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> Maximum Reservation Number
      </div>
      <div class="manual-explain">
        Displayed when "Date (Period)" is selected for reservation unit (red frame H).<br>
        Enter the maximum number of reservations per day.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/J.png"> Do Not Display Usage Days (Extended Stay)
      </div>
      <div class="manual-explain">
        Displayed when "Date (Period)" is selected for reservation unit (red frame H).<br>
        Select whether to display extended stay days on the user screen.<br>
        Checking this will hide the display.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/K.png"> Time Slots
      </div>
      <div class="manual-explain">
        Displayed when "Time Slot" is selected for reservation unit (red frame H).<br>
        Set time slots (start time-end time) available for reservation within a day.<br>
        Users can select only one time slot per day when making reservations, but
        checking "Allow multiple time slot selection per day" enables multiple selections.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/L.png"> Reservation Questions (Basic Items: Display with Check)
      </div>
      <div class="manual-explain">
        Set whether to display basic items on the user screen during reservation.<br>
        Checked items will be displayed.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/M.png"> Reservation Questions (Basic Items: If you want to rename "Remarks")
      </div>
      <div class="manual-explain">
        Set the title of the "Remarks" input form during user reservation.<br>
        Open the <a [href]="userInputTitleDialogLink">edit dialog</a> from the edit button to configure.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/N.png"> Reservation Questions (Custom Items)
      </div>
      <div class="manual-explain">
        Select custom items to display on the user screen (below basic items) during reservation.<br>
        Custom items can be registered from the reservation question function.<br>
      </div>

    </mat-card-content>
    <div>
      <br><br>
    </div>

    <!-- Reservation Email -->
    <mat-card-content>
      <div class="manual-explain-title">
        ▼Reservation Email Page
      </div>
      <div class="manual-img">
        <img src="assets/img/manual/en_reservation-facility-dialog3.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> User Reservation Completion: Email Content Settings
      </div>
      <div class="manual-explain">
        ▼Set the email content sent when making a reservation when the reservation method (red frame G) on the reservation input page is "First-come, first-served", or when confirming a reservation when the reservation method is "Lottery" or "Hold".<br>
        <br>
        Email Title: <span class="manual-explain-notes">*Required field</span><br>
        Set the title of the reservation completion email sent to the user.<br>
        Email Body (Header): <span class="manual-explain-notes">*Required field</span><br>
        Set the text to be placed at the beginning of the reservation completion email sent to the user (★ section in the content below).<br>
        Email Body (Middle):<br>
        Set the text to be placed in the middle of the reservation completion email sent to the user (★★ section in the content below).<br>
        Email Body (Footer):<br>
        Set the text to be placed at the end of the reservation completion email sent to the user (★★★ section in the content below).<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        <br>
        The email body structure is as follows:<br>
        ------------------------------------------------<br>
        <br>
        ★Email Body (Header)<br>
        <br>
        ▼Reservation Details<br>
        Reservation Number: 12345678<br>
        Company Name: XX Corporation<br>
        Department: XX Department<br>
        Position: Manager<br>
        Name: Taro Yamada<br>
        Name (Kana): Yamada Taro<br>
        Email Address: xxxxxxxxxxx<br>
        Mobile Phone Number: 09011112222<br>
        <br>
        Usage Date:<br>
        &nbsp;&nbsp;&nbsp;2024-02-23<br>
        Usage Time:<br>
        &nbsp;&nbsp;&nbsp;11:00 - 14:00<br>
        Reservation Cancellation Deadline:<br>
        &nbsp;&nbsp;&nbsp;Day of use<br>
        <br>
        Requests:<br>
        None in particular<br>
        <br>
        Please cancel your reservation from the link below.<br>
        (※Reservation number and email address are required. Please be mindful of the cancellation deadline.)<br>
        &nbsp;&nbsp;&nbsp;https://xxxxxxxxxxx/reservation-cancel/000001<br>
        <br>
        ★★Email Body (Middle)<br>
        <br>
        * This email is automatically sent due to facility usage reservation.<br>
        * This email is for sending only, so we cannot respond even if you reply. Please understand.<br>
        <br>
        ★★★Email Body (Footer)<br>
        ------------------------------------------------<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> User Reservation Completion: Secretariat Notification Email Content Settings
      </div>
      <div class="manual-explain">
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reservation completion email sent to the secretariat (★ section in the content below).<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        <br>
        The email body structure is as follows:<br>
        ------------------------------------------------<br>
        <br>
        ★Email Body (Header)<br>
        <br>
        ▼Reservation Details<br>
        Reservation Name: Tennis Court<br>
        Reservation Number: 12345678<br>
        Email: xxxxxxxxx&#64;test.com<br>
        Usage Date:<br>
        &nbsp;&nbsp;&nbsp;2024-02-23<br>
        Usage Time:<br>
        &nbsp;&nbsp;&nbsp;11:00 - 14:00<br>
        ------------------------------------------------<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> User Reservation Completion Email Body Display Control
      </div>
      <div class="manual-explain">
        Check if there are items you do not want to display in the email content sent to users upon reservation completion (refer to the email body in User Reservation Completion: Email Content Settings).<br>
        Target items are reservation cancellation deadline and reservation cancellation link.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> User Reservation Cancellation: Email Content Settings
      </div>
      <div class="manual-explain">
        Email Title:<br>
        Set the title of the reservation cancellation email sent to the user.<br>
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reservation cancellation email sent to the user.<br>
        Email Body (Middle):<br>
        Set the text to be placed in the middle of the reservation cancellation email sent to the user.<br>
        Email Body (Footer):<br>
        Set the text to be placed at the end of the reservation cancellation email sent to the user.<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        ※Refer to the email body in User Reservation Completion: Email Content Settings for the email body structure<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> User Reservation Cancellation: Secretariat Notification Email Content Settings
      </div>
      <div class="manual-explain">
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reservation cancellation email sent to the secretariat (refer to the email body in User Reservation Completion: Secretariat Notification Email Content Settings).<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> Reminder Email: Email Content Settings
      </div>
      <div class="manual-explain">
        Email Title:<br>
        Set the title of the reminder email sent to the user.<br>
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reminder email sent to the user.<br>
        Email Body (Middle):<br>
        Set the text to be placed in the middle of the reminder email sent to the user.<br>
        Email Body (Footer):<br>
        Set the text to be placed at the end of the reminder email sent to the user.<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        ※Refer to the email body in User Reservation Completion: Email Content Settings for the email body structure<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/G.png"> Reminder Email Settings
      </div>
      <div class="manual-explain">
        Send reminder emails to users who have completed reservations 1-7 days before the usage date.<br>
        You can select up to 2 options from 1-7 days before.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/H.png"> Email Notification Settings to Secretariat
      </div>
      <div class="manual-explain">
        If you want to send email notifications to the secretariat upon reservation completion/cancellation, register an email address.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/I.png"> User Reservation Hold: Email Content Settings
      </div>
      <div class="manual-explain">
        ▼Displayed when the reservation method (red frame G) on the reservation input page is "Lottery" or "Hold".<br>
        Set the email content sent when making a reservation.<br>
        <br>
        Email Title:<br>
        Set the title of the reservation hold email sent to the user.<br>
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reservation hold email sent to the user.<br>
        Email Body (Middle):<br>
        Set the text to be placed in the middle of the reservation hold email sent to the user.<br>
        Email Body (Footer):<br>
        Set the text to be placed at the end of the reservation hold email sent to the user.<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        ※Refer to the email body in User Reservation Completion: Email Content Settings for the email body structure<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/J.png"> User Reservation Rejection: Email Content Settings
      </div>
      <div class="manual-explain">
        ▼Displayed when the reservation method (red frame G) on the reservation input page is "Lottery" or "Hold".<br>
        Set the email content sent when rejecting a reservation.<br>
        <br>
        Email Title:<br>
        Set the title of the reservation rejection email sent to the user.<br>
        Email Body (Header):<br>
        Set the text to be placed at the beginning of the reservation rejection email sent to the user.<br>
        Email Body (Middle):<br>
        Set the text to be placed in the middle of the reservation rejection email sent to the user.<br>
        Email Body (Footer):<br>
        Set the text to be placed at the end of the reservation rejection email sent to the user.<br>
        Open the <a [href]="sendMailMessageDialogLink">edit dialog</a> from the edit button to configure.<br>
        ※Refer to the email body in User Reservation Completion: Email Content Settings for the email body structure<br>
      </div>

    </mat-card-content>

    <!-- SPLATS Key -->
    <mat-card-content>
      <div class="manual-explain-title">
        ▼SPLATS Key Page
      </div>
      <div class="manual-img">
        <img src="assets/img/manual/en_reservation-facility-dialog4.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> Environment
      </div>
      <div class="manual-explain">
        Select the environment to which the key box belongs.<br>
        When you select an environment, the list of key boxes owned by that environment will be displayed in the key box.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> Key Box
      </div>
      <div class="manual-explain">
        Select a key box.<br>
        When you select a key box, the list of keys owned by that key box will be displayed in the key.<br>
        ※Key boxes must be registered in advance on the <a [href]="facilityDialogLink">Facility Information (Add/Edit) screen</a>.<br>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Key
      </div>
      <div class="manual-explain">
        Select a key.<br>
        Key names that are in use by other reservation facilities are displayed in red.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> Borrowing Grace Time
      </div>
      <div class="manual-explain">
        Select the grace time for borrowing the key.<br>
        For example, if the reservation facility usage start time is 9:00 and the borrowing grace time is set to 10 minutes, the key can be borrowed from 8:50.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> Return Grace Time
      </div>
      <div class="manual-explain">
        Select the grace time for returning the key.<br>
        For example, if the reservation facility usage end time is 12:00 and the return grace time is set to 10 minutes, the key can be returned until 12:10.
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> Questions (Basic Items: Output with Check)
      </div>
      <div class="manual-explain">
        Set whether to output basic items along with the QR code used when opening the key box. (Maximum 5)<br>
        Checked items will be output.<br>
      </div>

    </mat-card-content>

  </mat-card>

  </div>
</div>

